var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7661_7157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.714875 10.4219C0.70637 12.5588 2.43187 14.2981 4.56889 14.3066C5.55307 14.3105 6.50179 13.9393 7.22188 13.2684L12.9881 15.8718C12.9481 16.0874 12.9261 16.306 12.9224 16.5252C12.9156 18.677 14.6544 20.4268 16.8061 20.4336C18.9578 20.4404 20.7076 18.7016 20.7144 16.5499C20.7213 14.3982 18.9825 12.6483 16.8307 12.6415C15.5452 12.6375 14.3404 13.2678 13.6107 14.3262L8.19319 11.8801C8.57799 10.9509 8.57947 9.90722 8.19736 8.97696L13.6074 6.5183C14.8256 8.28024 17.2415 8.72095 19.0035 7.50272C20.7654 6.28449 21.2061 3.86863 19.9878 2.10669C18.7696 0.344752 16.3537 -0.0959565 14.5918 1.12227C13.5425 1.84779 12.917 3.04284 12.919 4.31854C12.9225 4.53812 12.9448 4.75695 12.9856 4.97274L7.23437 7.58617C5.67616 6.123 3.22687 6.20006 1.7637 7.75826C1.08653 8.47949 0.711208 9.43257 0.714875 10.4219Z",
    fill: "#00504E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7661_7157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.714844 0.433594)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.957b347b52c00526691c06115043dbcd.svg";
export { ForwardRef as ReactComponent };